import React from 'react';
import { Instagram, Phone, Mail, MapPin, Dumbbell } from 'lucide-react';
import { clubData, contactData } from '../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-black border-t border-[#39FF14]/20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <Dumbbell className="w-8 h-8 text-[#39FF14]" />
              <div>
                <div className="text-[#39FF14] font-black text-xl">TRAINING</div>
                <div className="text-white text-xs">Club Esportiu Orpí</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              El teu espai d'entrenament a Carme, Orpí i rodalies
            </p>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold mb-4">Contacte</h3>
            <div className="space-y-3 text-sm">
              <a href={`tel:${contactData.phone}`} className="flex items-center gap-2 text-gray-400 hover:text-[#39FF14] transition-colors">
                <Phone className="w-4 h-4" />
                {contactData.phone}
              </a>
              <a href={`mailto:${contactData.email}`} className="flex items-center gap-2 text-gray-400 hover:text-[#39FF14] transition-colors break-all">
                <Mail className="w-4 h-4" />
                {contactData.email}
              </a>
              <div className="flex items-start gap-2 text-gray-400">
                <MapPin className="w-4 h-4 mt-0.5" />
                <span>{contactData.address}</span>
              </div>
            </div>
          </div>

          {/* Hours & Social */}
          <div>
            <h3 className="text-white font-bold mb-4">Horari</h3>
            <p className="text-gray-400 text-sm mb-4">
              <span className="text-[#39FF14] font-bold">{contactData.hours}</span>
              <br />
              {contactData.daysOpen}
            </p>
            <a
              href={clubData.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#39FF14]/10 hover:bg-[#39FF14]/20 text-[#39FF14] px-4 py-2 rounded-lg transition-colors"
            >
              <Instagram className="w-5 h-5" />
              <span className="text-sm font-bold">Segueix-nos</span>
            </a>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Training Club Esportiu Orpí. Tots els drets reservats.
          </p>
          <p className="text-gray-600 text-xs mt-2">
            {contactData.president} - {contactData.role}
          </p>
        </div>
      </div>
    </footer>
  );
};
